// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// #endregion

@Component({
  selector: 'hs-editbox',
  templateUrl: './editbox.component.html',
  styleUrls: ['./editbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditboxComponent),
      multi: true
    },
  ]
})
export class EditboxComponent implements OnInit, ControlValueAccessor {
  @Input() numberOfLines: number;
  @Input() debounceMilliseconds: number;
  @Input() placeholderText = '';

  @Output() lostFocus = new EventEmitter();
  @Output() buttonClick = new EventEmitter<string>();

  @ViewChild('controlFrame') controlFrame: ElementRef | undefined;


  isDisabled: boolean = false;

  value: string = '';
  disabled: boolean = false;
  private _localvalue: string | undefined;

  private _onChange: ((value: string) => void) | undefined;
  private _onTouched: (() => void) | undefined;

  constructor() {
    this.numberOfLines = 1;
    this.debounceMilliseconds = 600;
    this.placeholderText = '';
  }

  ngOnInit() { }

  get unSavedChanges() {
    return this.value !== this._localvalue;
  }

  onValueChanged(event: any): void {
    if (!this._onChange) return;

    this.value = event.target.value;
    this._onChange(this.value);
  }

  writeValue(value: string = ''): void {
    if (value) {
      this.value = value;
      this._localvalue = value;
    } else {
      this.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onFocus(): void {
    //roll into top of scroll
    //console.log("EditboxComponent: onFocus scrollIntoView");
    /*this.controlFrame?.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });*/
    if (!this._onTouched) return;

    this._onTouched();
  }

  onBlur(event: any): void {
    this.lostFocus.emit(this);
  }

  onButtonClick() {
    this._localvalue = this.value;
    this.buttonClick.emit(this.value);
  }
}
